import React from 'react';

import './streamStub.scss';

interface Props {}

const StreamComponent: React.SFC<Props> = () => (
    <div styleName="container" className="__app-StreamStub-container" />
);

export default StreamComponent;
